<div class="form-group" *ngIf="progress > 0">
    <div class="progress">
        <mat-progress-bar [value]="progress"></mat-progress-bar>
    </div>
  </div>